import React, { useEffect, useState } from 'react';

// Packages
import { Page, Text, View, Document, Image } from '@react-pdf/renderer';
import moment from 'moment';
import PropTypes from 'prop-types';

// Components
import PayloadScore from './PayloadScore';
import PayloadContent from './PayloadContent';

// Images
import GEPP from './gepp.jpg';

// Styles
import { styles, colors } from './styles';

// Utils
import { epochToLocalDate } from '../../../utils/dateConverter';

const GeppDataSheet = (props) => {
	const { title, locationInfo, locationData, payloadInfo, indicatorsProgress, parsedPayload } = props;

	const [newParsedPayload, setNewParsedPayload] = useState([]);

	const getDataSheetDate = () => {
		const fecha = new Date();

		moment.locale(localStorage.getItem('i18nextLng'));
		const fechaFormateada = moment(fecha).format('LLL');

		return fechaFormateada;
	}

	useEffect(() => {
		const parsedPayloadCpy = global.structuredClone(parsedPayload);

		if (parsedPayload.length > 0) {
			parsedPayloadCpy.forEach((item) => {
				Object.keys(item).map((key, keyIdx) => {
					if (key.includes('refris-')) {
						item[key].items = [ { 'Numero de Refri': keyIdx + 1 } , ...item[key].items ]
					}
					if (key.includes('racks-')) {
						item[key].items = [ { 'Numero de Rack': keyIdx + 1 } , ...item[key].items ]
					}
				});
			});
		}

		setNewParsedPayload(parsedPayloadCpy);
	}, [parsedPayload]);

	const getProcessType = (processType) => {
		if (processType === 1) return 'Online';
		if (processType === 3) return 'Offline';
	}

	return (
		<Document>
			{/* <Page size='A4' style={styles.page}> */}
			<Page size={[842, 595]} style={styles.page}>
				<View style={styles.mainView}>
					{/* Header */}
					<View style={styles.header}>
						<Image src={GEPP} style={styles.headerLogo} />
						<View style={styles.columnHeader}>
						</View>
						<View style={styles.columnHeader}>
							<Text style={styles.headerTitle}>{title}</Text>
						</View>
						<View style={styles.columnHeader}>
							<Text style={styles.headerDate}>{getDataSheetDate()}</Text>
						</View>
					</View>
					{/* Store Data */}
					<View>
						<View style={styles.section}>
							<Text style={styles.sectionText}>Datos de la Tienda</Text>
						</View>
						<View style={{ padding: 3 }}>
							<View style={styles.flexWrap}>
								<View style={{ ...styles.columnStoreData, width: '16%' }}>
									<Text style={styles.boldTex}>Región:  </Text>
									<Text style={styles.normalText}>{payloadInfo?.region?.name}</Text>
								</View>
								<View style={{ ...styles.columnStoreData, width: '29.5%' }}>
									<Text style={styles.boldTex}>Territorio:  </Text>
									<Text style={styles.normalText}>{payloadInfo?.zone?.name}</Text>
								</View>
								<View style={{ ...styles.columnStoreData, width: '38%' }}>
									<Text style={styles.boldTex}>CEDIS:  </Text>
									<Text style={styles.normalText}>{payloadInfo?.depot?.name} - {payloadInfo?.depot?.description}</Text>
								</View>
								<View style={{ ...styles.columnStoreData, width: '8.5%' }}>
									<Text style={styles.boldTex}>Grupo:  </Text>
									<Text style={styles.normalText}>{payloadInfo?.group?.name}</Text>
								</View>
								<View style={{ ...styles.columnStoreData, width: '8%' }}>
									<Text style={styles.boldTex}>Ruta:  </Text>
									<Text style={styles.normalText}>{payloadInfo?.route?.code}</Text>
								</View>
							</View>
							<View style={styles.flexWrap}>
								<View style={{ ...styles.columnStoreData, width: '16%' }}>
									<Text style={styles.boldTex}>CUC:  </Text>
									<Text style={styles.normalText}>{locationInfo?.code}</Text>
								</View>
								<View style={{ ...styles.columnStoreData, width: '29.5%' }}>
									<Text style={styles.boldTex}>Nombre:  </Text>
									<Text style={styles.normalText}>{locationInfo?.name}</Text>
								</View>
								<View style={{ ...styles.columnStoreData, width: '54%' }}>
									<Text style={styles.boldTex}>Dirección:  </Text>
									<Text style={styles.normalText}>{locationData?.data?.direccion_completa}</Text>
								</View>
							</View>
						</View>
					</View>
					{/* Payload Info */}
					<View>
						<View style={styles.section}>
							<Text style={styles.sectionText}>Información del Censo</Text>
						</View>
						<View style={{ padding: 3 }}>
							<View style={styles.flexWrap}>
								<View style={{ ...styles.columnStoreData, width: '20%' }}>
									<Text style={styles.boldTex}>Ciclo:  </Text>
									<Text style={styles.normalText}>{payloadInfo?.cycle?.name}</Text>
								</View>
								<View style={{ ...styles.columnStoreData, width: '29.5%' }}>
									<Text style={styles.boldTex}>Fecha de Censo:  </Text>
									<Text style={styles.normalText}>{epochToLocalDate(payloadInfo?.date?.$date, localStorage.getItem('i18nextLng'))}</Text>
								</View>
								<View style={{ ...styles.columnStoreData }}>
									<Text style={styles.boldTex}>Modo: </Text>
									<Text style={styles.normalText}>{getProcessType(payloadInfo?.process_type)}</Text>
								</View>
							</View>
						</View>
					</View>
					{/* Indicators */}
					{indicatorsProgress?.details?.length > 0 && (
						<PayloadScore
							total={indicatorsProgress?.score}
							indicators={indicatorsProgress?.details}
						/>
					)}
					{/* Content */}
					<PayloadContent
						parsedPayload={parsedPayload}
					/>
				</View>
			</Page>
		</Document>
	);
}

GeppDataSheet.propTypes = {
	title: PropTypes.string,
	locationInfo: PropTypes.object,
	locationData: PropTypes.object,
	payloadInfo: PropTypes.object,
	indicatorsProgress: PropTypes.object,
	parsedPayload: PropTypes.array
};

export default GeppDataSheet;
